import React from "react";
import Processes from "./Processes";
export default function Complaints() {
  return (
    <div>
      <Processes />
    </div>
  );
}
